import { Container, Grid } from '@mui/material'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { toast } from 'react-toastify'
import { Auth } from '../../../Component/Api/Auth/AuthService'
import { PageLayout } from '../../../Component/Common/Container/PageLayout'
import { MFARequest, SecurityInfo, TokenRequest } from '../../../Component/Model/SignIn'
import { defaultObject } from '../../../Helpers/typescriptHelper'
import { coreTokenAtom, tokenAtom } from '../../../State/Token.Atom'
import { TwoFactorContent } from './TwoFactorContent'

export const TwoFactorPage = () => {
    const history = useHistory();
    const location = useLocation<any>();
    const setToken = useSetRecoilState<string>(tokenAtom);
    const setCoreToken = useSetRecoilState<string>(coreTokenAtom);

    const [securityInfo, setSecurityInfo] = React.useState<SecurityInfo>(defaultObject);
    const [TwoFactorButtonText, setTwoFactorButtonText] = React.useState<string>("Enable Two Factor Authentication");

    const CancelTwoFactorCard = () => {
        history.push('/login');
    }

    const coreLogin = async (username: string, password: string) => {
        try {
            const result = await Auth.login(username, password);
            setCoreToken(result.data.token);
            history.push('/home');
        } catch (error) {
            console.log(error);
        }
    }

    const handleTFARequest = async (request: MFARequest) => {
        try {
            const tokenRequest: TokenRequest = {
                RememberMe: location.state.RememberMe,
                grant_type: location.state.grant_type,
                username: location.state.username,
                password: location.state.password,
                loginType: location.state.loginType,
            }
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('grant_type', tokenRequest.grant_type);
            bodyFormData.append('username', tokenRequest.username);
            bodyFormData.append('password', tokenRequest.password);
            bodyFormData.append('RememberMe', tokenRequest.RememberMe);
            bodyFormData.append('TwoFactorCode', request.Code);
            bodyFormData.append('PreshareSecret', request.SecretKey);

            const result = await Auth.Token(bodyFormData);
            setToken(result.data.access_token);
            await coreLogin(tokenRequest.username, tokenRequest.password);
        } catch (error: any) {
            const errorMessage = error.response?.data.error_description || "User authentication failed.";
            toast.error(errorMessage);
        }
    }

    const LoadSecurityData = (data: SecurityInfo) => {
        setSecurityInfo(data);
        setTwoFactorButtonText('Enable Two Factor Authentication');
    }

    React.useEffect(() => {
        try {
            Auth.GenerateTwoFactorAuthInfo(location.state.username).then(result => {
                LoadSecurityData(result.data);
            })
        } catch (error) {
            console.log(error);
        }
    }, []);


    return (
        <PageLayout>
            <Container>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}>
                    <TwoFactorContent
                        securityInfo={securityInfo}
                        LoadSecurityData={LoadSecurityData}
                        TwoFactorButtonText={TwoFactorButtonText}
                        CancelTwoFactorCard={CancelTwoFactorCard}
                        OnCancelAddTwoFactorAuthenticationDeviceClick={CancelTwoFactorCard}
                        OnChangeTwoFactorAuthenticationDeviceClick={() => { }}
                        handleTFARequest={handleTFARequest}
                        ShowAddTwoFactorAuthenticationDevice={true}
                        ShowCancelAddTwoFactorAuthenticationDevice={false}
                        ShowCurrentTwoFactorAuthenticationConfiguration={false}

                    />
                </Grid>
            </Container>
        </PageLayout>
    )
}